package com.example.readingnotes.presentation.postlist

sealed interface PostListEvent {
    data object OnAppear : PostListEvent

    data object OnRefresh : PostListEvent

    data object OnLoadMore : PostListEvent

    data object OnRetry : PostListEvent

    // Search events
    data class OnSearchQueryChanged(
        val query: String,
    ) : PostListEvent

    data object OnSearchSubmit : PostListEvent

    data object OnClearSearch : PostListEvent

    // Sort events
    data class OnSortChanged(
        val sortBy: SortOption,
    ) : PostListEvent

    // Filter events
    data class OnStatusFilterChanged(
        val status: String?,
    ) : PostListEvent

    // Tag filter events
    data class OnTagFilterToggled(
        val tag: String,
    ) : PostListEvent

    data object OnClearTagFilters : PostListEvent

    data class OnPopularTagsLoaded(
        val tags: List<com.example.readingnotes.domain.model.TagWithCount>,
    ) : PostListEvent
}
